import React from 'react';

import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { EikaModal } from '../../../components/EikaModal';

type Props = {
    open: boolean;
    setOpen: React.Dispatch<boolean>;
};

const DemoModal: React.FC<Props> = ({ open, setOpen }) => (
    <EikaModal open={open} setOpen={setOpen} contentShouldStretch>
        <InfoCard style={{ margin: 'auto 0' }} data-testid="demo-modal-info-message">
            <RichIcon maxHeight={160} minHeight={160} type={RichIconTypes.HAAND_HEIHEI} />
            <InfoCard.TitleH3>Not allowed</InfoCard.TitleH3>
            <p>Disabled in demo mode</p>
        </InfoCard>
    </EikaModal>
);

export default DemoModal;
